/**
 * Живой эфир волны (MADR 0040): клиент в бою шлёт серверу текущую волну — состояние забежки на старте, сид, все команды с
 * тиками и тик сейчас. Сервер держит её в памяти, зритель (админка) крутит ту же волну на движке с отставанием.
 * Чанк самодостаточен: сервер после перезапуска собирает картинку с первого же чанка. В прогресс и журналы ничего не пишется.
 */
import { z } from "zod";
import { TimedCommand } from "./commands";
import { PosInt, Seed, Tick } from "./common";
import { RunState } from "./wave-log";

/** Что игрок видит сейчас: бой, выбор усиления, окно поверх боя, свёрнуто. */
export const LiveUi = z.object({
  state: z.enum(["battle", "boost", "window", "hidden"]),
  /** Вид окна оболочки при `window` (`defeat`, `vip`, `shop`…). */
  window: z.string().max(32).optional(),
});
export type LiveUi = z.infer<typeof LiveUi>;

export const MAX_LIVE_COMMANDS = 500;

/** Текущая волна игрока целиком (не дельта): повтор чанка безвреден. */
export const LiveChunk = z.object({
  runId: z.uuid(),
  wave: PosInt,
  seed: Seed,
  /** Состояние забежки на старте волны — то, с чего зритель создаёт бой. */
  start: RunState,
  /** Автонавыки разрешены (VIP), как `WaveLog.vip`. */
  vip: z.boolean().optional(),
  commands: z.array(TimedCommand).max(MAX_LIVE_COMMANDS),
  /** Тик волны у игрока в момент отправки. */
  tick: Tick,
  ui: LiveUi,
});
export type LiveChunk = z.infer<typeof LiveChunk>;

/** Потолок тела чанка. */
export const MAX_LIVE_BYTES = 32 * 1024;

/** Событие зрителю (SSE `GET /api/live/watch/:id`): снимок при подключении и каждый новый чанк. */
export const LiveEvent = z.object({
  player: z.object({ id: z.uuid(), name: z.string() }),
  /** `null` — игрок сейчас не в игре (чанков не было или они устарели). */
  chunk: LiveChunk.nullable(),
  /** Когда чанк пришёл на сервер, мс Unix. */
  at: z.number().int().nonnegative().nullable(),
});
export type LiveEvent = z.infer<typeof LiveEvent>;
